/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliInstitutionConfigDtoApiResponse } from '../../models/amoxcalli-institution-config-dto-api-response';
import { AmoxcalliUpsertInstitutionConfigDto } from '../../models/amoxcalli-upsert-institution-config-dto';

export interface ApiInstitutionConfigPut$Plain$Params {
      body?: AmoxcalliUpsertInstitutionConfigDto
}

export function apiInstitutionConfigPut$Plain(http: HttpClient, rootUrl: string, params?: ApiInstitutionConfigPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliInstitutionConfigDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiInstitutionConfigPut$Plain.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliInstitutionConfigDtoApiResponse>;
    })
  );
}

apiInstitutionConfigPut$Plain.PATH = '/api/institution-config';
